export class InfoPep {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
        politicas: {
            value: null, 
            required: 'Por favor seleccione', 
            header: 'Su entidad/negocio/actividad cuenta con políticas y procedimientos de prevención de lavado de activos, financiamiento del terrorismo y otros delitos?'
        },
        sancion: {
            value: null, 
            required: 'Por favor seleccione', 
            header: '¿Ha recibido su entidad/persona alguna sanción o multa, o tiene algún procedimiento legal por incumplimiento a las disposiciones de la Ley de Orgánica de Prevención, Detección y Erradicación del Delito de Lavado de Activos y del Financiamiento de Delitos, o al Código Orgánico Integral Penal, o alguna norma conexa en la materia en los últimos doce meses?'
        },
        socio: {
            value: null,
            required: 'Por favor seleccione',
            header: 'Es usted, el Representante Legal o algún Socio/Accionista un PEP?',
            headerPorTipo: {
                FRM_TOYOTA: 'Es usted, el Representante Legal o algún Socio/Accionista/Directivo un PEP?',
                FRM_DIFARE: 'Es usted, el Representante Legal o algún Socio/Accionista/Directivo un PEP?',
            }
        },
        nombre_pep: {
            value: '', 
            header: 'Nombre del PEP:', 
            required: 'Nombres es requerido', 
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 300, 
            min: 4
        },
        cargo_pep: {
            value: '', 
            header: 'Cargo:', 
            required: 'Cargo es requerido', 
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 300, 
            min: 4
        },
        institucion_pep: {
            value: '', 
            header: 'Institución donde trabaja o trabajó:', 
            required: 'Institución es requerido', 
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 300, 
            min: 4
        },
        fecha_pep: {
            value: new Date(),
            header: 'Fecha del nombramiento de la designación (día/mes/año):',
            headerPorTipo: {
                FRM_TOYOTA: 'Fecha del nombramiento:',
                FRM_DIFARE: 'Fecha del nombramiento:',
            },
            required: 'Fecha es requerido'
        },
        fecha_no_pep: {
            value: null,
            header: 'Fecha en que dejó de ser PEP, de no estar en funciones (día/mes/año):',
            headerPorTipo: {
                FRM_TOYOTA: 'Fecha de culminación:',
                FRM_DIFARE: 'Fecha de culminación:',
            },
            required: false
        },
        relacion_pep: {
            value: null, 
            required: 'Por favor seleccione',
            header: 'El Representante Legal o algún Socio/Accionista/Directivo está relacionado con un PEP:'
        },
        relacion_vinculo_pep: {
            value: '', 
            header: 'Relación o vínculo:', 
            required: 'Relación es requerida', 
            maxLength: 'Máximo 150 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 150, 
            min: 4
        },
        nombre_vinculo_pep: {
            value: '', 
            header: 'Nombre del PEP:', 
            required: 'Nombres es requerido', 
            maxLength: 'Máximo 150 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 150, 
            min: 4
        },
        cargo_vinculo_pep: {
            value: '', 
            header: 'Cargo:', 
            required: 'Cargo es requerido', 
            maxLength: 'Máximo 150 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 150, 
            min: 4
        },
        institucion_vinculo_pep: {
            value: '', 
            header: 'Institución donde trabaja o trabajó:', 
            required: 'Institución es requerido', 
            maxLength: 'Máximo 150 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 150, 
            min: 4
        },
        fecha_vinculo_pep: { 
            value: new Date(), 
            header: 'Fecha del nombramiento:', 
            required: 'Fecha es requerido'
        },
        fecha_culminacion_pep: {
            value: null,
            header: 'Fecha de culminación:',
            required: false
        }
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }

    optionLabel = 'nombre';

    strPep = <><p style={{ textAlign: 'justify' }}><b>PEP</b>: Son todas aquellas personas naturales, nacionales o extranjeras, que desempeñan o han desempeñado funciones o cargos públicas destacados en el Ecuador o en el
        Extranjero; o funciones prominentes en una organización internacional, conforme a los lineamentos establecidos por la Unidad de Análisis Financiero y Económico (UAFE), y el organismo
        de control respectivo.</p><p style={{ textAlign: 'justify' }}><b>FAMILIARES O RELACIONADOS</b>: Son las relaciones comerciales o contractuales que involucren al cónyuge o a las personas unidas bajo el régimen legal de unión
            de hecho reconocida legalmente; o a familiares comprendidos hasta el segundo grado de consanguinidad o primero de afinidad; y, el o los colaborador (es) directo (s) esto es la (s)
            persona (s) natural (es) con las cuales una Persona Expuesta Políticamente (PEP). se encuentre asociada o vinculada societariamente, o mantenga otro tipo de relaciones empresariales,
            comerciales o laborales estrechas, serán consideradas como PEP.</p></>;
}
